import { AccountData } from './accountData';
import { Integrations } from './../enums/integrations';
import { IntegrationApiKeys } from './integrationApiKeys';

export class Integration {
  public type: Integrations;
  public callback?: string;
  public accountData: AccountData;
  public apiKeys: IntegrationApiKeys;

  public constructor(data?: any) {
    this.type = (data && data.type) ? data.type : Integrations.CUSTOM;
    this.callback = (data && data.callback) ? data.callback : undefined;
    this.accountData = (data && data.accountData) ? new AccountData(data.accountData) : new AccountData();
    this.apiKeys = (data && data.apiKeys) ? data.ApiKeys : {}
  }
}
